var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDifferencePrizes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 23.0435V41.1304H46V23.0435H14ZM43.9131 27.2173H41.8261V29.3043H43.9131V34.8695H41.8261V36.9564H43.9131V39.0433H41.8261V36.9564H39.7392V39.0433H20.2609V36.9564H18.1739V39.0433H16.0869V36.9564H18.1739L18.1739 34.8695H16.0869V29.3043H18.1739V27.2174H16.0869V25.1305H18.1739V27.2174H20.2608V25.1305H39.7391V27.2174H41.826V25.1305H43.9129V27.2173H43.9131Z",
    fill: "#FFFF81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7825 27.2173H27.2173V29.3042H32.7825V27.2173Z",
    fill: "#FFFF81"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7825 34.8696H27.2173V36.9566H32.7825V34.8696Z",
    fill: "#FFFF81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8697 29.3044H32.7827V34.8696H34.8697V29.3044Z",
    fill: "#FFFF81"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2173 29.3044H25.1304V34.8696H27.2173V29.3044Z",
    fill: "#FFFF81"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46 18.8696H14V20.9566H46V18.8696Z",
    fill: "#FFFF81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifferencePrizes);
export default __webpack_public_path__ + "static/media/difference_prizes.39a15dcf52d2559ee0f8ef0bdca56918.svg";
export { ForwardRef as ReactComponent };